export const GET_USER_BY_ID = 'GET_USER_BY_ID'
export const REMOVE_USER_BY_ID = 'REMOVE_USER_BY_ID'
export const GET_USERS_BY_IDS = 'GET_USERS_BY_IDS'
export const SAVE_USERS = 'SAVE_USERS'
